import { ConfirmationDialogService } from './../../../../confirmation-dialog/confirmation-dialog.service';
import { URLUtils } from 'src/app/urlUtils';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LeavepageComponent } from '../leavepage/leavepage.component';
import { GeneralleavepageComponent } from 'src/app/matter/genaralmatter/creategeneralmatter/generalleavepage/generalleavepage.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatterService } from 'src/app/matter/matter.service';
import { take } from 'rxjs';
import { HostListener } from '@angular/core';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { SuccessDialogComponent } from 'src/app/success-dialog/success-dialog.component';


@Component({
    selector: 'matter-documents',
    templateUrl: 'matter-documents.component.html',
    styleUrls: ['matter-documents.component.scss'],
    standalone: false
})
export class MatterDocumentsComponent {
    @Output() selectedDocumentsEvent: EventEmitter<any> = new EventEmitter();
    @ViewChild('selectAllCheckbox') selectAllCheckbox!: ElementRef<HTMLInputElement>;
    @Output() docsSaved = new EventEmitter<boolean>();
    @Input() data: any = {};
    @Input() docsWereSaved:any;
    @Input() groups: any[] = [];
    @Input() clients: any[] = [];
    @Input() clientsData: any[] = [];
    @Input() corporate:any[] = [];
    @Input() matterId: any;
    @Input() docsData:any[]=[];
    files: File[] = [];
    currentTab: string = 'existingdoc';
    documentsList: any = [];
    matters: any;
    filter: any;
    uploadDocs: any = [];
    selectedDocuments: any = [];
    searchText: any = '';
    editMetaData: boolean = false;
    editMetaFlag: boolean = true;
    selectedIdx: any;
    editDoc: boolean = false;
    editMeta: any;
    downloadDisabled = false;
    encryptDisabled = false;
    values: any = [];
    metaData: any;
    submitted = false;
    documentDetail: any = FormGroup;
    @ViewChild('file')
    myInputVariable!: ElementRef;
    filteredData:any;
    isSelectAllVisible = true;
    groupName:any;
    showAllItems = false;
    pathName: string = "legalmatter";
    product = environment.product;
    originalClientsList:any[]=[];
    uploadedDocs: any = [];
    isDragOver = false;
    addTag: boolean = false;
    allCheck: boolean = false;
    noOfDocs: number = 0;
    isDisableDoc: boolean = true;
    today = new Date();
    minDate = new Date(this.today);   // copy of today
    maxDate = new Date(this.today);   // copy of today
    isIndeterminate = false;
    objectKeys = Object.keys;
    description:any;
    showTagInputs: boolean = false;
    currentDocTags: any[] = [];
    private uploadSuccessPopupShown = false;
    editeMatterInfo: any;
    isEdit: boolean = false;
    docid:any='';
    isFormSaved = false;

    expirationDatePickerConfig = {
        dateInputFormat: 'MMM DD, YYYY',
        showWeekNumbers: false,
        showClearButton: true,
        minDate: new Date()
        //maxDate: new Date()
    };

    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload(event: BeforeUnloadEvent) {
        if (this.hasUnsavedChanges()) {
            event.preventDefault();
            event.returnValue = ''; // Required for Chrome/Edge
        }
    }

    getDocList:any[]=[];
    constructor(private httpservice: HttpService,private toast: ToastrService,
        private fb: FormBuilder,private dialog: MatDialog, private router: Router,
        private confirmationDialogService: ConfirmationDialogService,private spinnerService: NgxSpinnerService,
        private matterService: MatterService
    ) { }

    ngOnInit() {
        if(this.docsWereSaved === false){
            this.uploadedDocs = [];
        }

        this.values.push({ tagtype: "", tag: "" });
        this.getDocs();
        this.currentTab = 'uploadnew';
        this.documentDetail = this.fb.group({
            name: ['', Validators.required],
            description: [''],
            date_of_filling: [new Date()]
        })
        //console.log(this.documentDetail.get('date_of_filling')?.value);

         if (window.location.pathname.indexOf("edit") > -1) {
        this.matterService.editLegalMatterObservable.pipe(take(1)).subscribe((result: any) => {
        // console.log('lm-result',result)
        if (result) {
         
          this.matterId = result.id;
          this.editeMatterInfo = result;
          this.isEdit = true;
          this.uploadedDocs = this.editeMatterInfo?.documents || [];
         

        //   console.log('ss selectedDocuments in edit:',this.uploadDocs)

          
        }
        // else if(result.error)
        // this.toast.error(result.msg)
      })
       this.matterService.editGeneralMatterObservable.pipe(take(1)).subscribe((result: any) => {
        if (result) {
         
          this.matterId = result.id;
          this.editeMatterInfo = result;        
          this.isEdit = true;
           this.uploadedDocs = this.editeMatterInfo?.documents || [];
        }
        // else if(result.error)
        // this.toast.error(result.msg)
      })

        }

        this.uploadedDocs = (this.editeMatterInfo?.documents || []).map((doc: any) => ({
            ...doc,
            size: doc.size || 0,
            file: null,
            tags: doc.tags || [],
            downloadDisabled: !!doc.downloadDisabled,
            custom_encrypt: !!doc.custom_encrypt
        }));
        this.groupName = this.clients.map((obj: any) => obj?.name);
    }

    private hasUnsavedChanges(): boolean {
        // Any of these mean user changed something and didn’t save yet
        if (this.uploadedDocs?.length > 0) return true;
        if (this.uploadDocs?.length > 0) return true;
        if (this.selectedIdx !== null && this.editDoc) return true;
        if (this.documentDetail?.dirty) return true;

        return false;
    }

    // getDocs() {
    //     this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(this.matterId)).subscribe(
    //         (res: any) => {
    //             this.getDocList = res.documents;
    //             console.log('doc-res', res)
    //         })
    // }
    getDocs() {
    this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(this.matterId)).subscribe(
        (res: any) => {
            this.getDocList = res.documents;
            console.log('doc-res', this.getDocList);

            // Merge exp_date into uploadedDocs after getDocList is ready
            this.uploadedDocs = this.uploadedDocs.map((doc: any) => {
                const meta = this.getDocList.find((d: any) => d.docid === doc.docid);
                let expiryDate = null;
                if (meta?.exp_date) {
                    const [day, month, year] = meta.exp_date.split('-');
                    expiryDate = new Date(+year, +month - 1, +day);
                }
                return {
                    ...doc,
                    date_of_filling: expiryDate  // now available for upload
                };
            });
        }
    );
}
    // public handleFileInput(event: Event | { target: { files: FileList } }) {
    //     const input = (event as any).target as HTMLInputElement;
    //     if (input && input.files) {
    //         for (let i = 0; i < input.files.length; i++) {
    //             const file = input.files[i];

    //             const allowedTypes = [
    //                 'image/png', 'image/heif', 'image/webp', 'image/ico', 'image/jpg',
    //                 'image/jpeg', 'image/arw', 'image/bmp', 'image/svg', 'image/tiff',
    //                 'application/pdf', 'application/msword',
    //                 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    //                 'application/vnd.ms-powerpoint',
    //                 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    //                 'application/vnd.ms-excel',
    //                 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    //                 'application/rtf', 'text/csv', 'text/rtf', 'text/plain'
    //             ];

    //             if (allowedTypes.includes(file.type)) {

    //                 this.files.push(file);

    //                 this.uploadedDocs.push(file);
    //                 this.uploadDocs.push(file);
    //                 this.selectedDocuments.push(file);

    //             } else {
    //                 this.toast.error('Invalid file format!');
    //             }
    //         }
    //     }
    //     //this.filterDoc('editMeta');
    // }

    handleFiles(files: FileList) {
        let allowedTypes = ['image/png', 'image/heif', 'image/webp', 'image/ico', 'image/jpg', 'image/jpeg', 'image/arw', 'image/bmp', 'image/svg', 'image/tiff',
            'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/rtf', 'text/csv', 'text/rtf', 'text/plain'];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            if (allowedTypes.includes(file.type)) {
                // this.files.push(file);
                // this.uploadedDocs.push(file);
                // this.uploadDocs.push(file);
                // this.selectedDocuments.push(file);
                // console.log('dd', this.downloadDisabled);
                // console.log('ee', this.encryptDisabled);

                const docObj = {
                name: file.name,
                type: file.type,
                size: file.size,   // ✅ STORE SIZE IN BYTES
                file: file,        // ✅ KEEP ORIGINAL FILE
                description: '',
                date_of_filling: null,
                tags: [],
                downloadDisabled: false,
                custom_encrypt: false
            };

            this.files.push(file);          // keep if your upload uses this
            this.uploadedDocs.push(docObj); // ✅ use object, not raw file
            this.uploadDocs.push(docObj);
            this.selectedDocuments.push(docObj);

            
            } else {
                this.toast.error(`Invalid file format: ${file.name}`);
            }
        }
        this.docEnable('disable');
    }

    handleFileInput(event: Event | { target: { files: FileList } }) {
        const input = (event as any).target as HTMLInputElement;

        if (input.files) {
            this.handleFiles(input.files);
            input.value = '';
        }
    }

    onDragEnter(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        // REQUIRED FOR FIREFOX
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'copy';
        }
        this.isDragOver = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;

        const files = event.dataTransfer?.files;

        if (files && files.length > 0) {
            this.handleFiles(files);
            event.dataTransfer?.clearData();
        }
    }


    get f() {
        return this.documentDetail.controls;
    }
    removevalue(i: any) {
        this.values.splice(i, 1);
    }

    addvalue() {
        this.values.push({ tagtype: "", tag: "" });
    }
    // submit() {
    //     this.editMetaFlag = true;
    //     //console.log(JSON.stringify(this.values));
    //     let resultObj: any = {};

    //     this.values.forEach((item: any) => {
    //         resultObj[item.tagtype] = item.tag

    //     });
    //     this.metaData = resultObj;
    //     //console.log("tagsArray  " + JSON.stringify(resultObj));
    // }
    submit() {
        //Check each item in the values
        for (const item of this.values) {
            if (!item.tag.trim() || !item.tagtype.trim()) {
                this.toast.error('Please fill all fields');
                return;
            }
        }
        this.noOfDocs = 0
        this.editMetaFlag = true;
        //console.log(JSON.stringify(this.values));
        let resultObj: any = {};

        this.values.forEach((item: any) => {
            resultObj[item.tagtype] = item.tag

        });
        this.metaData = resultObj;
        this.addTag = false;
        //console.log("tagsArray  " + JSON.stringify(resultObj));
    }
    getDocuments() {
        this.groupName = this.groups.map((obj: any) => obj.name);;
        //console.log('grp',this.groups)
        //var cli = []
        let grps = this.groups.map((obj: any) => obj.id);
        
        // console.log('clients:', this.clients);
        // console.log('corporate:', this.corporate);

        let cli = this.clients.map((obj: any) => obj.id);

        //cli.push(this.corporate)
      

        // if (Array.isArray(this.corporate)) {
        //     cli.push(...this.corporate); // Add elements from the array
        // } else if (this.corporate) {
        //     cli.push(this.corporate); // Add single value
        // }
        // Remove empty arrays or falsy values
        // cli = cli.filter((item: any) => item && !(Array.isArray(item) && item.length === 0));

        if (this.corporate.length > 0) {
            cli.push(this.corporate);
        }
        else {
            cli = cli.filter(item => item !== null && item !== undefined && item !== '');
        }

        //console.log('cli',cli)

        this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements,
            { 'group_acls': grps, 'attachment_type': 'documents', 'clients': cli }).subscribe(
                (res: any) => {
                    console.log('doc-res',res)
                    if (!res['error'] && res['documents']?.length > 0) {
                        this.documentsList = res['documents'];
                        this.originalClientsList = this.documentsList;
                    }
                })
        if (this.documentsList.length === 0) {
            let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
            if (checkbox != null)
                checkbox.checked = true;
        }
    }
    // getDocuments() {
    //     // Extract group names and IDs
    //     this.groupName = this.groups.map((obj: any) => obj.name);
    //     console.log('grp', this.groupName);

    //     let grps = this.groups.map((obj: any) => obj.id);
    //     let cli = this.clients.map((obj: any) => obj.id);

    //     // Add corporate to the client list if not empty
    //     if (this.corporate && !(Array.isArray(this.corporate) && this.corporate.length === 0)) {
    //         if (Array.isArray(this.corporate)) {
    //             cli.push(...this.corporate); // Spread array if corporate is an array
    //         } else {
    //             cli.push(this.corporate); // Push single value
    //         }
    //     }

    //     // Filter out empty arrays or falsy values
    //     cli = cli.filter((item: any) => item && !(Array.isArray(item) && item.length === 0));

    //     console.log('cli:', cli);
    //     console.log('clients:', this.clients);
    //     console.log('corporate:', this.corporate);

    //     // Send PUT request
    //     this.httpservice.sendPutRequest(
    //         URLUtils.getFilterTypeAttachements,
    //         { 'group_acls': grps, 'attachment_type': 'documents', 'clients': cli }
    //     ).subscribe((res: any) => {
    //         if (!res['error'] && res['documents']?.length > 0) {
    //             this.documentsList = res['documents'];
    //             this.originalClientsList = this.documentsList;
    //         }
    //     });

    //     // Handle checkbox state
    //     if (this.documentsList.length === 0) {
    //         const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //         if (checkbox) checkbox.checked = true;
    //     }
    // }

    selectDocument(document: any) {
        this.selectedDocuments.push(document);
        let index = this.documentsList.findIndex((d: any) => d.docid === document.docid); //find index in your array
        this.documentsList.splice(index, 1);
        // if (this.documentsList.length==0) {
        //     let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        //     if (checkbox != null)
        //       checkbox.checked = true;
        //   }
        if (this.documentsList.length === 0 && this.selectAllCheckbox) {
            //console.log('checkbox', this.selectAllCheckbox.nativeElement);
            this.selectAllCheckbox.nativeElement.checked = true;
          }
        //this.searchText = '';
        this.httpservice.setDocs(this.selectedDocuments); //observing the selectedDocs
    }

    removeDocument(doc: any) {
        let index = this.selectedDocuments.findIndex((d: any) => d.docid === doc.docid); //find index in your array
        this.selectedDocuments.splice(index, 1);
        this.documentsList.push(doc);
        if (this.selectedDocuments.length == 0 || this.documentsList.length==1) {
            let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
            if (checkbox != null)
                checkbox.checked = false;
        }
    }
    getFileDetails(event: any) {
        for (var i = 0; i < event.files.length; i++) {
            let file: File = event.files[i]
            this.files.push(file);
                let object = {
                    name: event.files[i].name.split('.')[0],
                    description: event.files[i].name.split('.')[0],
                    type: event.files[i].type,
                    file: file,
                    groups: this.groups.map((obj: any) => obj.id),
                    client: this.clients,
                    matter: this.matters,
                    category: this.filter,
                }
            this.uploadDocs.push(object);
        this.myInputVariable.nativeElement.value = '';
        }
    }
    // selectAllxx(event: any) {
    //     if (event?.target?.checked) {
    //         if (this.documentsList?.length > 0) {
    //             if(this.filteredData?.length>0){
    //                 this.selectedDocuments = this.selectedDocuments.concat(this.documentsList);
    //                 this.documentsList = this.documentsList.filter((el: any) => {
    //                   return !this.selectedDocuments.find((element: any) => {
    //                     return element.docid === el.docid;
    //                   });
    //                 });
    //               }else{
    //             this.selectedDocuments = this.selectedDocuments.concat(this.documentsList);
    //             this.documentsList = [];
    //               }
    //         }
    //     } else {
    //         this.documentsList = this.selectedDocuments.concat(this.documentsList);
    //         this.selectedDocuments = [];
    //     }
    //     this.searchText = '';
    // }

    selectAll(event: any) {
        if (event?.target?.checked) {
            if (this.documentsList?.length > 0) {
                const filteredClients = this.documentsList.filter((client: any) =>
                    client.name.toLowerCase().includes(this.searchText.toLowerCase())
                );
                if (filteredClients?.length > 0) {
                    this.selectedDocuments = this.selectedDocuments.concat(filteredClients);
                    this.documentsList = this.documentsList.filter((el: any) => {
                        return !this.selectedDocuments.find((element: any) => {
                            return element.id === el.id;
                        });
                    });
                }
                else {
                    this.documentsList = this.selectedDocuments.concat(this.documentsList);
                    this.selectedDocuments = [];
                }
            }
         } 
         else {
            this.documentsList = this.selectedDocuments.concat(this.documentsList);
            this.selectedDocuments = [];
        }

        this.searchText = '';
        this.handlefocus();
        this.httpservice.setDocs(this.selectedDocuments); //observing the selectedDocs
    }

    handlefocus(){
        setTimeout(() => {
            const textareas = document.querySelectorAll('.form-control.textbox.searchtextcr');
            const lastTextarea = textareas[textareas.length - 1] as HTMLTextAreaElement;
            if (lastTextarea) {
                lastTextarea.focus();
        
                // Simulate keydown and keyup events for Enter
                const keydownEvent = new KeyboardEvent('keydown', {
                    key: 'Enter',
                    code: 'Enter',
                    bubbles: true,
                });
                const keyupEvent = new KeyboardEvent('keyup', {
                    key: 'Enter',
                    code: 'Enter',
                    bubbles: true,
                });
        
                lastTextarea.dispatchEvent(keydownEvent);
                lastTextarea.dispatchEvent(keyupEvent);
            }
        }, 100);
    }

    // saveDocuments() {
    //     // console.log('uploadedDocs', this.uploadedDocs);
    //     // console.log('uploadDocs', this.uploadDocs);
    //     // console.log('selectedDocs', this.selectedDocuments);
    //     // console.log('files', this.files);
    //     // console.log('documentDetail', this.documentDetail.value);
    //     // console.log('editdoc', this.editDoc);
    //     // const existingDocs = this.uploadedDocs.filter((d:any) => d.docid);
    //     // const newDocs = this.uploadedDocs.filter((d:any) => !d.docid);
    //     // console.log(existingDocs)
    //     // console.log(newDocs) 
    //     // if (this.isEdit && existingDocs.length > 0 && newDocs.length === 0) {
    //     //     console.log(this.matter_type)
    //     //     const url =
    //     //     this.matter_type === 'legal'
    //     //         ? URLUtils.legalHistoryDocumentsUpdate(this.data.id)
    //     //         : URLUtils.generalHistoryDocumentsUpdate(this.data.id);

    //     //     this.httpservice
    //     //         .sendPutRequest(
    //     //         url,
    //     //         { documents: this.selectedDocuments }
    //     //         )
    //     //         .subscribe({
    //     //         next: () => {
    //     //             // this.toast.success('Changes saved successfully');
    //     //             this.docsSaved.emit(true);
    //     //         },
    //     //         error: () => {
    //     //             this.toast.error('Failed to save changes');
    //     //         }
    //     //         });

    //     //     return; 
    //     //     }
    //     if (this.uploadedDocs.length==0 || this.uploadDocs.length==0 || this.currentTab === 'existingdoc') {
    //         // this.toast.success('Saved 1')
    //         // this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully created the matter.', true, 'View Matter List', 'Add New Matter', true, 'sm', true, true)
    //         //     .then((confirmed) => {
    //         //         if (confirmed) {
    //         //             this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    //         //             const path = window.location.pathname;

    //         //             if (path.indexOf("create") > -1) {
    //         //                 if (path.includes("legal")) {
    //         //                     this.router.navigate(['/matter/legalmatter/view']);
    //         //                 }
    //         //                 else {
    //         //                     this.router.navigate(['/matter/generalmatter/view']);
    //         //                 }
    //         //             }
    //         //         } else {
    //         //             window.location.reload();
    //         //         }
    //         //     })

    //         this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    //         //console.log('pathname', this.pathName)

    //         this.router.navigate([`/matter/${this.pathName}/view`]);

    //         this.selectedDocumentsEvent.emit(this.selectedDocuments);
    //         this.docsSaved.emit(true);
    //     }
    //     else {
    //         const uploadPromises = [];
            
    //         //this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    //         const path = window.location.pathname;
    //         if (path.indexOf("create") > -1) {
    //             for (var i = 0; i < this.uploadedDocs.length; i++) {
    //                 let fdata = new FormData();
    //                 this.description = this.uploadedDocs[i].description?.trim() || this.uploadedDocs[i].name;
    //                 //const ids = this.data.groups.map((obj: any) => obj.id);
    //                 //const groupAcls = this.data.groupAcls;
    //                 fdata.append('name', this.uploadedDocs[i].name);
    //                 fdata.append('description', this.description);
    //                 //fdata.append('description', this.uploadedDocs[i].description);
    //                 fdata.append('filename', this.uploadedDocs[i].name)
    //                 fdata.append('content_type', this.uploadedDocs[i].type)
    //                 fdata.append('category', "client")
    //                 //fdata.append('group_acls', JSON.stringify(this.data.groupAcls))
    //                 // if (ids.length > 0) {
    //                 //   fdata.append('groups', JSON.stringify(ids))
    //                 // }
    //                 //fdata.append('groups', JSON.stringify(groupAcls))
    //                 fdata.append('file', this.files[i])
    //                 fdata.append('matters', JSON.stringify([this.matterId]));
    //                 // let sb = [this.data?.title];
    //                 // let mtrs = [this.data?.id];
    //                 // // fdata.append('subcategories', JSON.stringify(sb))
    //                 // // fdata.append('matters', JSON.stringify(mtrs))
    //                 // merge clients + corporate safely

    //                 const clients = [
    //                     ...(this.clients || []),
    //                     ...(this.corporate || [])
    //                 ];

    //                 // append only if clients exist
    //                 if (clients.length) {
    //                     const clientsPayload = clients.map((obj: any) => ({
    //                         id: obj.id,
    //                         type: obj.type
    //                     }));

    //                     fdata.append('clients', JSON.stringify(clientsPayload));
    //                 }

    //                 const formatDate = (dateString: string | Date): string => {
    //                     const date = new Date(dateString);
    //                     const day = String(date.getDate()).padStart(2, '0');
    //                     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    //                     const year = date.getFullYear();
    //                     return `${day}-${month}-${year}`;
    //                 };

    //                 // Format expiration_date if it exists
    //                 const formattedExpirationDate = this.uploadedDocs[i].date_of_filling ? formatDate(this.uploadedDocs[i].date_of_filling) : '';
    //                 console.log('while uploading .uploadedDocs',this.uploadedDocs)
    //                 fdata.append('expiration_date', formattedExpirationDate);
    //                 //fdata.append('downloadDisabled', this.downloadDisabled.toString()); 
    //                 //fdata.append('encryptDisabled', this.encryptDisabled.toString());
    //                 // fdata.append('downloadDisabled', this.uploadedDocs[i].downloadDisabled);
    //                 // fdata.append('custom_encrypt', this.uploadedDocs[i].custom_encrypt);

    //                 fdata.append('downloadDisabled', (!!this.uploadedDocs[i].downloadDisabled).toString());
    //                 fdata.append('custom_encrypt', (!!this.uploadedDocs[i].custom_encrypt).toString());
    //                 let tagsObj: any = {};

    //                 if (this.uploadedDocs[i].tags?.length > 0) {
    //                     this.uploadedDocs[i].tags.forEach((tag: any) => {
    //                         if (tag.tagtype?.trim() && tag.tag?.trim()) {
    //                             tagsObj[tag.tagtype.trim()] = tag.tag.trim();
    //                         }
    //                     });
    //                 }

    //                 if (Object.keys(tagsObj).length > 0) {
    //                     fdata.append('tags', JSON.stringify(tagsObj));
    //                 }

    //                 this.upload(i, fdata, this.uploadedDocs[i]) //trigger upload
    //             }
    //         }
    //         else{
    //             console.log('edited Blockkkkkk')
    //              for (var i = 0; i < this.uploadDocs.length; i++) {
    //             let fdata = new FormData();
    //             this.description = this.uploadDocs[i].description?.trim() || this.uploadDocs[i].name;
    //             //const ids = this.data.groups.map((obj: any) => obj.id);
    //             //const groupAcls = this.data.groupAcls;
    //             fdata.append('name', this.uploadDocs[i].name);
    //             fdata.append('description', this.description);
    //             //fdata.append('description', this.uploadedDocs[i].description);
    //             fdata.append('filename', this.uploadDocs[i].name)
    //             fdata.append('content_type', this.uploadDocs[i].type)
    //             fdata.append('category', "client")
    //             //fdata.append('group_acls', JSON.stringify(this.data.groupAcls))
    //             // if (ids.length > 0) {
    //             //   fdata.append('groups', JSON.stringify(ids))
    //             // }
    //             //fdata.append('groups', JSON.stringify(groupAcls))
    //             const file =
    //             this.files?.[i] ||
    //             this.uploadedDocs?.[i]?.file;

    //             if (!file) {
    //             continue; 
    //             }
    //             fdata.append('file', file)
    //             fdata.append('matters', JSON.stringify([this.matterId]));
    //             // let sb = [this.data?.title];
    //             // let mtrs = [this.data?.id];
    //             // // fdata.append('subcategories', JSON.stringify(sb))
    //             // // fdata.append('matters', JSON.stringify(mtrs))
    //             // merge clients + corporate safely
               
    //             const clients = [
    //             ...(this.clients || []),
    //             ...(this.corporate || [])
    //             ];

    //             // append only if clients exist
    //             if (clients.length) {
    //             const clientsPayload = clients.map((obj: any) => ({
    //                 id: obj.id,
    //                 type: obj.type
    //             }));

    //             fdata.append('clients', JSON.stringify(clientsPayload));
    //             }

    //             const formatDate = (dateString: string | Date): string => {
    //                 const date = new Date(dateString);
    //                 const day = String(date.getDate()).padStart(2, '0');
    //                 const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    //                 const year = date.getFullYear();
    //                 return `${day}-${month}-${year}`;
    //             };

    //             // Format expiration_date if it exists
    //             const formattedExpirationDate = this.uploadDocs[i].date_of_filling ? formatDate(this.uploadDocs[i].date_of_filling) : '';
    //             console.log('formt exp',formattedExpirationDate)
    //             fdata.append('expiration_date', formattedExpirationDate);

    //             //fdata.append('downloadDisabled', this.downloadDisabled.toString()); 
    //             //fdata.append('encryptDisabled', this.encryptDisabled.toString());
    //             // fdata.append('downloadDisabled', this.uploadedDocs[i].downloadDisabled);
    //             // fdata.append('custom_encrypt', this.uploadedDocs[i].custom_encrypt);

    //             fdata.append('downloadDisabled', (!!this.uploadDocs[i].downloadDisabled).toString());
    //             fdata.append('custom_encrypt', (!!this.uploadDocs[i].custom_encrypt).toString());
    //             let tagsObj: any = {};

    //             if (this.uploadDocs[i].tags?.length > 0) {
    //                 this.uploadDocs[i].tags.forEach((tag: any) => {
    //                     if (tag.tagtype?.trim() && tag.tag?.trim()) {
    //                         tagsObj[tag.tagtype.trim()] = tag.tag.trim();
    //                     }
    //                 });
    //             }

    //             if (Object.keys(tagsObj).length > 0) {
    //                 fdata.append('tags', JSON.stringify(tagsObj));
    //             }

    //             this.upload(i, fdata, this.uploadDocs[i]) //trigger upload
    //         }
    //         }


    //         // this.confirmationDialogService.confirm('Confirmation', 'Are you sure you want to attach documents to ' + this.data.Title + ' ?',true, 'Yes', 'No')
    //         //     .then((confirmed) => {
    //         //         if (confirmed) {
    //         //             for (var i = 0; i < this.uploadDocs.length; i++) {
    //         //                 //console.log("test   " + JSON.stringify(this.uploadDocs));
    //         //                 let fdata = new FormData();
    //         //                 let matterList: any = [];
    //         //                 let sb:any=[]
    //         //                 matterList.push(this.matters)
    //         //                 const ids = this.groups.map((obj: any) => obj.id);
    //         //                 fdata.append('name', this.uploadDocs[i].name);
    //         //                 fdata.append('description', this.uploadDocs[i].description);
    //         //                 fdata.append('filename', this.uploadDocs[i].name)
    //         //                 fdata.append('content_type', this.uploadDocs[i].type)
    //         //                 fdata.append('category', 'client')
    //         //                 if (ids.length > 0) {
    //         //                     fdata.append('groups', JSON.stringify(ids))
    //         //                 }
    //         //                 // if (this.matters) { fdata.append('matters', JSON.stringify(matterList)) }

    //         //                 fdata.append('file', this.files[i])
    //         //                 fdata.append('matters', JSON.stringify([this.matterId]));

                               
    //         //                 //fdata.append('clients', JSON.stringify(this.clients))
    //         //                 // fdata.append('subcategories',sb.push(this.data?.Title))
    //         //                 fdata.append('downloadDisabled', this.downloadDisabled == true ? "Yes" : "No");
    //         //                 fdata.append('metadata', this.uploadDocs[i].checked == true ? JSON.stringify(this.metaData) : '');
    //         //                 this.upload(i, fdata)
    //         //             }
    //         //         }
    //         //     })
    //     }
    // }

    // upload( idx:any,file: any, data: any) {
    //     //return new Promise((resolve, reject) => {
    //     this.spinnerService.show();
    //     this.httpservice.sendPostRequest(URLUtils.postDocumentsClient, file).subscribe(
    //         (res: any) => {
    //             this.spinnerService.hide();
    //             if (!res.error) {
    //                 let obj = [{
    //                     "docid": res.docid,
    //                     "doctype": 'general',
    //                     "user_id": localStorage.getItem('user_id')
    //                 }];

    //                 var currentDateTime = new Date().toLocaleString('en-US', {
    //                     month: 'short',
    //                     day: '2-digit',
    //                     year: 'numeric',
    //                     hour: '2-digit',
    //                     minute: '2-digit',
    //                     hour12: true
    //                 });

    //                 let doc = {
    //                     "docid": res.docid,
    //                     "doctype": 'general',
    //                     "user_id": localStorage.getItem('user_id'),
    //                     "name": data.name,
    //                     "description": this.description,
    //                     "added_encryption": false,
    //                     "created": currentDateTime,
    //                     "addedBy": localStorage.getItem('name')
    //                 }
    //                 //console.log('doc',doc)

    //                 // this.AddExistingSelected = true; //return to exist
    //                 // this.UploadDocSelected = false; //return to exist

    //                 this.selectedDocuments.push(doc)
    //                 //this.createdBy = localStorage.getItem('name'); //Get value from localStorage
    //                 // this.httpservice.sendPutRequest(URLUtils.legalHistoryDocumentsUpdate(this.data.id), { "documents": obj }).subscribe(
    //                 //   (res: any) => {
    //                 //     //console.log(res);
    //                 //   });
    //                 //resolve(res.msg);
    //                 //this.toast.success(res.msg)
    //                 // this.AddExistingSelected = true;
    //                 // this.UploadDocSelected = false; 
    //                 this.values = [];
    //                 this.addvalue();
    //                 // this.getDocuments();
                    
    //                 this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    //                 //console.log('pathname', this.pathName)
    //                 // let cancel = localStorage.getItem('oncancel');
    //                 // if (cancel) {
    //                 //     this.toast.success(res.msg)
    //                 //     localStorage.removeItem('oncancel');
    //                 //     this.router.navigate([`/matter/${this.pathName}/view`]);
    //                 //     return;
    //                 // }
    //                 // else {
    //                 //     this.router.navigate([`/matter/${this.pathName}/view`]);
    //                 // }

    //                 if (!this.uploadSuccessPopupShown) {
    //                     this.uploadSuccessPopupShown = true;
    //                     //  const msg = this.isEdit ? 'Congratulations! You have successfully edited the matter.' : 'Congratulations! You have successfully created the matter.';
    //                     const msg = this.isEdit ? 'Matter Updated Successfully.' : 'Matter Created Successfully.';
    //                     this.toast.success(msg)

    //                     this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    //                     const path = window.location.pathname;
    //                     if (path.includes("legal")) {
    //                         this.router.navigate(['/matter/legalmatter/view']);
    //                     }
    //                     else {
    //                         this.router.navigate(['/matter/generalmatter/view']);
    //                     }

    //                     // this.confirmationDialogService.confirm('Success', msg, true, 'View Matter List', 'Add New Matter', true, 'sm', true, true)
    //                     // .then((confirmed) => {
    //                     //     if (confirmed) {
    //                     //         this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    //                     //         const path = window.location.pathname;

    //                     //        // if (path.indexOf("create") > -1) {
    //                     //             if (path.includes("legal")) {
    //                     //                 this.router.navigate(['/matter/legalmatter/view']);
    //                     //             }
    //                     //             else {
    //                     //                 this.router.navigate(['/matter/generalmatter/view']);
    //                     //             }
    //                     //        // }
    //                     //     } else {
    //                     //         window.location.reload();
    //                     //     }
    //                     // })

    //                     // const dialogRef = this.dialog.open(SuccessDialogComponent, {
    //                     //     width: '400px',
    //                     //     data: {
    //                     //         title: 'Success', message: msg,
    //                     //         cancelText: 'Add New Matter', confirmText: 'View Matter List'
    //                     //     }
    //                     // });
    //                     // dialogRef.afterClosed().subscribe((result: any) => {
    //                     //     //console.log('Dialog result:', result);
    //                     //     this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    //                     //     const path = window.location.pathname;

    //                     //     if (result) {
    //                     //         if (path.includes("legal")) {
    //                     //             this.router.navigate(['/matter/legalmatter/view']);
    //                     //         }
    //                     //         else {
    //                     //             this.router.navigate(['/matter/generalmatter/view']);
    //                     //         }
    //                     //     } else {
    //                     //         if (path.includes("legal")) {
    //                     //             this.router.navigate(['/matter/legalmatter/create']);
    //                     //         }
    //                     //         else {
    //                     //             this.router.navigate(['/matter/generalmatter/create']);
    //                     //         }
    //                     //     }

    //                     // });

    //                 }

    //                 // this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully upload document(s) to the matter.', true, 'View Matter List', 'Add New Matter', true, 'sm', true, true)
    //                 // .then((confirmed) => {
    //                 //     if (confirmed) {
    //                 //         this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    //                 //         const path = window.location.pathname;

    //                 //         if (path.indexOf("create") > -1) {
    //                 //             if (path.includes("legal")) {
    //                 //                 this.router.navigate(['/matter/legalmatter/view']);
    //                 //             }
    //                 //             else {
    //                 //                 this.router.navigate(['/matter/generalmatter/view']);
    //                 //             }
    //                 //         }
    //                 //     } else {
    //                 //         window.location.reload();
    //                 //     }
    //                 // })
    //             }
    //             else {
    //                 this.toast.error(res.msg)
    //                 //reject(res.msg);
    //             }

    //         },
    //         // (err: any) => {
    //         //   reject(err.msg);
    //         // }
    //         (error: HttpErrorResponse) => {
    //             this.spinnerService.hide();
    //             if (error.status === 400 || error.status === 401 || error.status === 403) {
    //                 const errorMessage = error.error.msg || 'Unauthorized';
    //                 this.toast.error(errorMessage);
    //                 //console.log(error);
    //             }
    //         }
    //     );
    //     //this.getDocuments();
    //     //});
    // }
      
    saveDocuments() {
        const path = window.location.pathname;
        this.pathName = path.includes("legalmatter") ? "legalmatter" : "generalmatter";

        const newDocs = this.uploadedDocs.filter((d: any) => !d.docid);

        // No new docs to upload — just navigate
        if (newDocs.length === 0 || this.currentTab === 'existingdoc') {
            this.selectedDocumentsEvent.emit(this.selectedDocuments);
            this.docsSaved.emit(true);
            this.router.navigate([`/matter/${this.pathName}/view`]);
            return;
        }

        const formatDate = (dateString: string | Date): string => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };

        const buildFormData = (doc: any, file: File): FormData => {
            const fdata = new FormData();
            const description = doc.description?.trim() || doc.name;

            fdata.append('name', doc.name);
            fdata.append('description', description);
            fdata.append('filename', doc.name);
            fdata.append('content_type', doc.type);
            fdata.append('category', 'client');
            fdata.append('file', file);
            fdata.append('matters', JSON.stringify([this.matterId]));

            const clients = [
                ...(this.clients || []),
                ...(this.corporate || [])
            ];
            if (clients.length) {
                const clientsPayload = clients.map((obj: any) => ({
                    id: obj.id,
                    type: obj.type
                }));
                fdata.append('clients', JSON.stringify(clientsPayload));
            }

            const formattedExpirationDate = doc.date_of_filling
                ? formatDate(doc.date_of_filling)
                : '';
            fdata.append('expiration_date', formattedExpirationDate);

            fdata.append('downloadDisabled', (!!doc.downloadDisabled).toString());
            fdata.append('custom_encrypt', (!!doc.custom_encrypt).toString());

            const tagsObj: any = {};
            if (doc.tags?.length > 0) {
                doc.tags.forEach((tag: any) => {
                    if (tag.tagtype?.trim() && tag.tag?.trim()) {
                        tagsObj[tag.tagtype.trim()] = tag.tag.trim();
                    }
                });
            }
            if (Object.keys(tagsObj).length > 0) {
                fdata.append('tags', JSON.stringify(tagsObj));
            }

            return fdata;
        };

        if (path.includes('create')) {
            // CREATE PATH — use uploadedDocs, files[] is parallel
            for (let i = 0; i < this.uploadedDocs.length; i++) {
                const doc = this.uploadedDocs[i];
                const file = this.files[i];

                if (!file) {
                    console.warn(`No file found at index ${i} for doc: ${doc.name}`);
                    continue;
                }

                const fdata = buildFormData(doc, file);
                this.upload(i, fdata, doc);
            }
        } else {
            // EDIT PATH — only upload new docs (no docid), find their file safely
            let fileIndex = 0;

            for (let i = 0; i < this.uploadedDocs.length; i++) {
                const doc = this.uploadedDocs[i];

                // Skip already-saved docs
                if (doc.docid) continue;

                // Use the file stored on the doc object (set in handleFiles)
                const file = doc.file || this.files[fileIndex];
                fileIndex++;

                if (!file) {
                    console.warn(`No file found for new doc: ${doc.name}`);
                    continue;
                }

                const fdata = buildFormData(doc, file);
                this.upload(i, fdata, doc);
            }
        }
    }

    upload(idx: any, file: any, data: any) {
        this.spinnerService.show();
        this.httpservice.sendPostRequest(URLUtils.postDocumentsClient, file).subscribe(
            (res: any) => {
                this.spinnerService.hide();

                if (!res.error) {
                    var currentDateTime = new Date().toLocaleString('en-US', {
                        month: 'short',
                        day: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    });

                    const doc = {
                        docid: res.docid,
                        doctype: 'general',
                        user_id: localStorage.getItem('user_id'),
                        name: data.name,
                        description: data.description?.trim() || data.name,
                        added_encryption: false,
                        created: currentDateTime,
                        addedBy: localStorage.getItem('name')
                    };

                    this.selectedDocuments.push(doc);
                    this.values = [];
                    this.addvalue();

                    if (!this.uploadSuccessPopupShown) {
                        this.uploadSuccessPopupShown = true;

                        const msg = this.isEdit
                            ? 'Matter Updated Successfully.'
                            : 'Matter Created Successfully.';

                        this.toast.success(msg);

                        this.pathName = window.location.pathname.includes("legalmatter")
                            ? "legalmatter"
                            : "generalmatter";

                        if (window.location.pathname.includes("legal")) {
                            this.router.navigate(['/matter/legalmatter/view']);
                        } else {
                            this.router.navigate(['/matter/generalmatter/view']);
                        }
                    }
                } else {
                    this.toast.error(res.msg);
                }
            },
            (error: HttpErrorResponse) => {
                this.spinnerService.hide();
                if (error.status === 400 || error.status === 401 || error.status === 403) {
                    const errorMessage = error.error?.msg || 'Unauthorized';
                    this.toast.error(errorMessage);
                }
            }
        );
    }

    filterDoc(data: any) {
        // this.addTag = !this.addTag;
        this.addTag = true;   // correct
        this.editDoc = false; 
        this.noOfDocs = this.uploadedDocs.filter((value: any) => value.checked).length;
        //console.log("===>", this.noOfDocs)

        if (data == 'editMeta') {
            this.editMetaData = true;
        }
        this.editMetaFlag = data == "editMeta" ? true : false;
    }

    // editDocument(item: any, i: any) {
    //     this.selectedIdx = i;
    //     this.editDoc = true;
    //    // this.editMeta = item;
    //     if(item.description)
    // this.documentDetail.controls["description"].setValue(item.description);
    // this.documentDetail.controls["date_of_filling"].setValue(item.date_of_filling);
    // this.documentDetail.controls["name"].setValue(item.name);
    //     //console.log(" this.editMeta  " + JSON.stringify(this.editMeta))
    // }
    editDocument(item: any, i: any) {
        console.log('item', item)
        console.log('iiiii', i)
        console.log('this.documentsList', this.documentsList)

        this.docid = item;
        //console.log('Editing document:', item, 'at index:', i);
        // Prevent editing multiple documents at once
        if (this.editDoc && this.selectedIdx !== null && this.selectedIdx !== i) {
            this.toast.warning('Please save or cancel your current edits before editing another document.');
            return;
        }

        // Toggle editing off if clicking the same document
        if (this.selectedIdx === i && this.editDoc) {
            this.cancelEdit();
            return;
        }

        this.selectedIdx = i;
        this.editDoc = true;
        this.addTag = false;

        // Load tags if they exist
        if (item.tags && Array.isArray(item.tags) && item.tags.length > 0) {
            this.currentDocTags = JSON.parse(JSON.stringify(item.tags));
            this.showTagInputs = true;
        } else {
            this.currentDocTags = [];
            this.showTagInputs = false;
        }

        // Set form values - auto-fill description if empty
        const descriptionValue = item.description && item.description.trim() !== ''
            ? item.description
            : item.name;

        this.documentDetail.patchValue({
            name: item.name,
            description: descriptionValue,
            date_of_filling: item.date_of_filling || null
        });

        console.log('this.getDocList', this.getDocList);
        console.log('this.documentDetail', this.documentDetail);
        console.log('---Uploaded docsss:', this.uploadedDocs);
        
        const docMeta = this.getDocList.find(
            (d: any) => d.docid === item.docid
        );
        console.log('docMeta', docMeta);

        let expiryDate = null;

        
        if (item.date_of_filling) {
            expiryDate = new Date(item.date_of_filling);
        }
        else if (docMeta?.exp_date) {
            const [day, month, year] = docMeta.exp_date.split('-');
            expiryDate = new Date(+year, +month - 1, +day);
        }

        console.log('expiryDate', expiryDate);

        this.documentDetail.patchValue({
            name: item.name,
            description: descriptionValue,
            date_of_filling: expiryDate
        });

    }
  
    // docEnable(item: any) {
    //     this.downloadDisabled = item == "enable" ? true : false;
    // }

    // checkedItem(val: any) {
    //     this.uploadDocs.forEach((item: any) => {
    //         if (item.name == val.name) {
    //             item.checked = true;
    //         }
    //     })
    // }

    checkedItem(event: Event, obj: any) {
        //this.addTag = true;
        const input = event.target as HTMLInputElement;
        const checked = input.checked;

        obj.checked = checked;
        this.noOfDocs = this.uploadedDocs.filter((v: any) => v.checked).length;

        const total = this.uploadedDocs.length;
        const selected = this.noOfDocs;

        this.allCheck = selected === total;                 // full select
        this.isIndeterminate = selected > 0 && selected < total; // partial
    }

    docEnable(action: string) {
        this.downloadDisabled = action == "enable" ? true : false;
        this.uploadedDocs.forEach((item: any) => {
            item.downloadDisabled = this.downloadDisabled;
        });
    }
    encryptEnable(action: string) {
        this.encryptDisabled = action === "enable" ? true : false;
        this.uploadedDocs.forEach((item: any) => {
            item.custom_encrypt = this.encryptDisabled;
        });
    }
    disableDoc(val: any, currentState: boolean) {
    val.downloadDisabled = !currentState;
    
    // Update in uploadedDocs array
    const index = this.uploadedDocs.findIndex((doc: any) => doc === val);
    if (index !== -1) {
        this.uploadedDocs[index].downloadDisabled = val.downloadDisabled;
    }
    //console.log('downloadDisabled set to', val.downloadDisabled);
}

    encrypttoggle(val: any, currentState: boolean) {
    val.custom_encrypt = !currentState;
    
    // Update in uploadedDocs array
    const index = this.uploadedDocs.findIndex((doc: any) => doc === val);
    if (index !== -1) {
        this.uploadedDocs[index].custom_encrypt = val.custom_encrypt;
    }
    // console.log('custom_encrypt set to', val.custom_encrypt);
}
    // removeNewDocument(item: any,i:number) {
    //     if( this.selectedIdx==i){
    //         this.editDoc = false;
    //         this.selectedIdx=null;
    //     }
    //     if( this.uploadDocs.length==1){
    //         this.editMetaData=false;
    //     }
    //     // let index = this.uploadDocs.findIndex((d: any) => d.id === item.id);
    //     this.uploadDocs.splice(i, 1);
    //     this.files.splice(i,1);
    // }
  

     removeNewDocument(item: any, i: number) {

  
  if (!item?.docid) {
    this.removeDocFromUI(i);
    this.toast.error('Document removed');
    return;
  }
  let payload = {
    "docids": [
      item.docid
    ]
}
 
  this.httpservice
    .sendPostRequest(URLUtils.deleteDocument, payload)
    .subscribe(
      (res: any) => {
        if (!res.error) {

          //this.delConfirm = false;

          this.confirmationDialogService.confirm(
            'Success',
            res.msg,
            false,
            'OK',
            '',
            true,
            'sm',
            true,
            false
          );
          this.removeDocFromUI(i);

          
        //   this.httpservice
        //     .sendGetRequest(URLUtils.legalHistoryDocuments(this.matterId))
        //     .subscribe((resp: any) => {
        //       this.selectedDocuments = resp.documents;
        //       this.removeDocFromUI(i);
        //     });

        } else {
          this.toast.error(res.msg);
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          this.toast.error(error.error?.msg || 'Unauthorized');
        }
      }
    );
}
   private removeDocFromUI(i: number) {

  if (this.selectedIdx === i) {
    this.editDoc = false;
    this.selectedIdx = null;
    this.currentDocTags = [];
    this.showTagInputs = false;
  }

  this.uploadedDocs.splice(i, 1);
  this.files.splice(i, 1);

  if (this.uploadedDocs.length === 0) {
    this.editMetaData = false;
    this.editDoc = false;
  }

  if (this.selectedIdx !== null && this.selectedIdx >= this.uploadedDocs.length) {
    this.selectedIdx = null;
    this.editDoc = false;
  }

  this.httpservice.setDocs(this.selectedDocuments);
}



    // checkAllItem(event: any) {
    //     if (event) {
    //         for (let i = 0; i < this.uploadDocs.length; i++) {
    //             this.uploadDocs[i].checked = true;
    //         }
    //     } else {
    //         for (let i = 0; i < this.uploadDocs.length; i++) {
    //             this.uploadDocs[i].checked = false;
    //         }
    //     }
    // }

    addTagRow() {
            if (!this.showTagInputs) {
                this.showTagInputs = true;
            }
            this.currentDocTags.push({ tagtype: "", tag: "" });
        }

        removeTagRow(index: number) {
            this.currentDocTags.splice(index, 1);
            if (this.currentDocTags.length === 0) {
                this.showTagInputs = false;
            }
        }
    checkAllItem(event: Event) {
        this.addTag = true;
        const input = event.target as HTMLInputElement;
        const checked = input.checked;

        this.allCheck = checked;
        this.isIndeterminate = false; // master clicked resets indeterminate
        this.uploadedDocs.forEach((doc: any) => doc.checked = checked);
        this.noOfDocs = this.uploadedDocs.filter((v: any) => v.checked).length;
    }
    // onResetTags() {
    //     this.editMetaFlag = true;
    //     this.values = [];
    // }
    // onReset() {
    //     this.submitted = false;
    //     // this.documentDetail.reset();
    //     this.editDoc = false;
    //     this.selectedIdx = null;
    //     //console.log(this.selectedIdx)
    // }

    onResetTags() {
        this.addTag = false
        this.noOfDocs = 0
        this.editMetaFlag = true;
        this.values = [];
        this.metaData = {};
        this.addvalue()
    }
  cancelEdit() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Alert', message: `Changes you made will not be saved. Do you want to continue?` }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.onReset();
      }
    });
  }
    onReset() {
    this.submitted = false;
    this.documentDetail.patchValue({
        name: '',
        date_of_filling: null,
        description: ''
    });
    this.editDoc = false;
    this.selectedIdx = null;
    this.currentDocTags = [];
    this.showTagInputs = false;
}

    // onSubmit() {
    //     if (this.documentDetail.invalid) {
    //         return;
    //       }
    //     this.uploadDocs[this.selectedIdx]=this.documentDetail.value;
    //     this.selectedIdx = null;
    //     this.submitted = true;
    //     this.editDoc = false;
    //     this.addTag = false;
    //     this.uploadDocs.forEach((val: any) => {
    //         //console.log("val     " + JSON.stringify(val));
    //     })
    // }
    onSubmit() {
    if (this.documentDetail.value.name == "") {
        this.toast.error('Please enter the document name');
        return;
    }
    
    // Validate tags if they're shown
    if (this.showTagInputs) {
        for (const item of this.currentDocTags) {
            if (!item.tagtype || !item.tagtype.trim() ||
                !item.tag || !item.tag.trim()) {
                this.toast.error('Please fill all tag fields or remove empty tags');
                return;
            }
            
            if (item.tagtype.length > 30) {
                this.toast.error('Tag Type cannot exceed 30 characters');
                return;
            }
            
            if (item.tag.length > 100) {
                this.toast.error('Tag cannot exceed 100 characters');
                return;
            }
        }
    }
    
    // Auto-fill description if empty
    const formValue = this.documentDetail.value;
    if (!formValue.description || formValue.description.trim() === '') {
        this.documentDetail.patchValue({
            description: formValue.name
        });
    }
    
    if (this.documentDetail.invalid) {
        return;
    }
 
    // Update the selected document with new values
    console.log('Uploaded docsss:', this.uploadedDocs);
    const updatedDoc = {
        ...this.uploadedDocs[this.selectedIdx],
        name: this.documentDetail.value.name,
        size: this.uploadedDocs[this.selectedIdx].size,
        description: this.documentDetail.value.description || this.documentDetail.value.name,
        date_of_filling: this.documentDetail.value.date_of_filling,
        tags: this.currentDocTags.filter(tag => 
            tag.tagtype && tag.tagtype.trim() && tag.tag && tag.tag.trim()
        ).map(tag => ({
            tagtype: tag.tagtype.trim(),
            tag: tag.tag.trim()
        }))
    };
    console.log('Updated document:', updatedDoc);
    
    this.uploadedDocs[this.selectedIdx] = updatedDoc;

    // console.log('Doc size:', this.uploadedDocs[this.selectedIdx]);
    // console.log('data',this.data)
    // console.log('Uploaded',this.uploadedDocs)
    // console.log('selectedDocuments',this.selectedDocuments)
    // console.log('eddd',this.editeMatterInfo)

    let documentsPayload = this.uploadedDocs.map((doc: any) => ({
        docid: doc.docid,
        doctype: doc.doctype,
        user_id: doc.user_id
    }));

     this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
     //console.log('pathname',this.pathName)

    if (window.location.pathname.indexOf("edit") > -1) {
        //let item = this.documentDetail.value;
        console.log('---id', this.docid);
        console.log('mattId',this.matterId)

        let id = this.docid?.docid;
        

        const formatDate = (date: Date) => {
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();

            return `${day}-${month}-${year}`;
        };

        const payload = {
            name: this.documentDetail.value.name,
            description: this.documentDetail.value.description,
            expiration_date: this.documentDetail.value.date_of_filling
                ? formatDate(this.documentDetail.value.date_of_filling)
                : ''
        };

        this.httpservice.sendPutRequest(URLUtils.updateDocument(id), payload)
            .subscribe(
                (res: any) => {
                    // if (res.error == true) {
                    //     this.toast.error(res.msg);
                    //     return;
                    // } else {
                    //     this.toast.success('Document metadata updated successfully');
                    // }
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                        const errorMessage = error.error.msg || 'Unauthorized';
                        this.toast.error(errorMessage);
                    }
        });


        if (this.pathName === "legalmatter") {
            this.httpservice.sendPutRequest(URLUtils.legalHistoryDocumentsUpdate(this.editeMatterInfo.id), { "documents": documentsPayload }).subscribe(
                (res: any) => {
                    // console.log(res);
                });
        }
        if (this.pathName === "generalmatter") {
            this.httpservice.sendPutRequest(URLUtils.generalHistoryDocumentsUpdate(this.editeMatterInfo.id), { "documents": documentsPayload }).subscribe(
                (res: any) => {
                    // console.log(res);
                });
        }
    }
    
    // Reset form state
    this.selectedIdx = null;
    this.submitted = true;
    this.editDoc = false;
    this.currentDocTags = [];
    this.showTagInputs = false;
    this.toast.success('Document metadata updated successfully');
}

    OnCancel() {
        // this.documentsList = this.documentsList.concat(this.selectedDocuments);
        // this.selectedDocuments = [];
        localStorage.setItem('oncancel', "oncancel");
        this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
        if (this.uploadedDocs.length > 0 || this.selectedDocuments.length > 0) {
            //this.saveDocuments();
            if(this.pathName === "legalmatter"){
                this.dialog.open(LeavepageComponent, {
                    width: '350px',  // Set the width here
                    height: '180px',
                    hasBackdrop: true,
                    panelClass: 'hello',
                    disableClose: true
                });
                return;
                }
                else if(this.pathName === "generalmatter"){
                    this.dialog.open(GeneralleavepageComponent, {
                        width: '350px',  // Set the width here
                        height: '180px',
                        hasBackdrop: true,
                        panelClass: 'hello',
                        disableClose: true
                    });
                    return; 
                }
            else {
                this.router.navigate([`/matter/${this.pathName}/view`]);
            }
        }
        else {
            this.router.navigate([`/matter/${this.pathName}/view`]);
        }
        const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox) {
            checkbox.checked = false;
        }
    }
        
    OnSaveLater() {
        // this.documentsList = this.documentsList.concat(this.selectedDocuments);
        // this.selectedDocuments = [];
        localStorage.setItem('oncancel', "oncancel");
        this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
        if (this.uploadedDocs.length > 0 || this.selectedDocuments.length > 0 || this.uploadedDocs.length === 0 || this.selectedDocuments.length === 0) {
            this.saveDocuments();
        }
        else {
            this.router.navigate([`/matter/${this.pathName}/view`]);
        }
        const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox) {
            checkbox.checked = false;
        }
    }

    // keyup(){
    //     if(this.searchText == ' ')
    //     this.searchText=this.searchText.replace(/\s/g, "");
    //     this.filteredData = this.documentsList.filter((item:any) =>item.name.toLocaleLowerCase().includes(this.searchText));
    //     let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //     if (checkbox != null)
    //       checkbox.checked = false;
    //   }
    keyup() {
        if (this.searchText == ' ') {
          this.searchText = this.searchText.replace(/\s/g, '');
        }
        //this.filteredData = this.documentsList.filter((item: any) => item.name.toLocaleLowerCase().includes(this.searchText));
        this.documentsList = this.originalClientsList.filter((item: any) =>
        item.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()) &&
        !this.selectedDocuments.includes(item)
    );
        // Update visibility based on the filtered data
        this.isSelectAllVisible = this.filteredData.length > 0;
    
        let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox != null) {
          checkbox.checked = false;
        }
      }
      truncateString(text: string): string {
        if (text.length > 25) {
          return text.slice(0, 25) + '...';
        }
        return text;
    }  
        
    // Function to toggle the view state
    toggleView() {
        this.showAllItems = !this.showAllItems;
    }

    restricttextSpace(event: any) {
    let inputValue: string = event.target.value;
    inputValue = inputValue.replace(/^\s+/, '');
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    event.target.value = inputValue;
  }
  
    checkDuplicateTagType(index: number) {
        const currentValue = this.currentDocTags[index]?.tagtype?.trim().toLowerCase();

        if (!currentValue) return;

        const duplicateIndex = this.currentDocTags.findIndex(
            (item: any, i: number) =>
                i !== index &&
                item.tagtype?.trim().toLowerCase() === currentValue
        );

        if (duplicateIndex !== -1) {
            this.currentDocTags[index].tagtype = ''; // Remove duplicate text
            this.toast.error('Duplicate tag types are not allowed.');
        }
    }

}
